import React from 'react';
import style from "./block.module.scss";
import colorsconfig from "../shared/colorPalette";
import {defineBlock, useEditor, ChildrenBlock, EditableImg, smartProps, useSmartProp, useInspectorControl, useToolbar, ColorToolbarButton} from "@smartfire/wordpress-react";
import { PanelBody, PanelRow, ToggleControl, ColorPalette, SelectControl } from '@wordpress/components';
import { InnerBlocks } from '@wordpress/block-editor';
import classnames from 'classnames'

function Toolbar() {
    const [backgroundColor, setBackgroundColor] = useSmartProp("backgroundColor");
    const colors = colorsconfig;
    return <>
            {colors && backgroundColor && <ColorToolbarButton colors={colors} color={backgroundColor} setColor={(c) => c ? setBackgroundColor(c) : null} />}
        </>
}

function Inspector(){
    const [fullWidth, setFullWidth] = useSmartProp('fullWidth');
    const [miroir, setMiroir] = useSmartProp("miroir");
    const [miroirMobile, setMiroirMobile] = useSmartProp("miroirMobile");
    const [encartPosition, setEncartPosition] = useSmartProp("positionEncart");
    const [backgroundEncart, setBackgroundEncart] = useSmartProp("backgroundEncart");
    const [losangeStyle, setLosangeStyle] = useSmartProp("losangeStyle");
    const [losangeMiroir, setLosangeMiroir] = useSmartProp("losangeMiroir");
    const [padding, setpadding] = useSmartProp("padding");
    const [ratio, setRatio] = useSmartProp("ratio");
    const colorsWithTransparent = [...colorsconfig, {name: "Transparent", color: "transparent"}];

    return <> 
        <PanelBody title="Largeur" initialOpen={true}>
            <PanelRow>
                <ToggleControl
                    label={fullWidth ? 'Largeur Home' : 'Largeur Page'}
                    checked={fullWidth}
                    onChange={() =>setFullWidth(!fullWidth)}
                />
            </PanelRow>
        </PanelBody>
        <PanelBody title="Position de l'image" initialOpen={true}>
            <PanelRow>
                <ToggleControl
                    label={miroir ? 'gauche' : 'droite'}
                    checked={miroir}
                    onChange={() =>setMiroir(!miroir)}
                />
            </PanelRow>
        </PanelBody>
        <PanelBody title="Ratio des colonnes" initialOpen={true}>
            <PanelRow>
                <ToggleControl
                    label={ratio ? '30:70' : '50:50'}
                    checked={ratio}
                    onChange={() =>setRatio(!ratio)}
                />
            </PanelRow>
        </PanelBody>
        <PanelBody title="Position de l'image sur mobile" initialOpen={true}>
            <PanelRow>
                <ToggleControl
                    label={miroirMobile ? 'Haut' : 'Bas'}
                    checked={miroirMobile}
                    onChange={() =>setMiroirMobile(!miroirMobile)}
                />
            </PanelRow>
        </PanelBody>
        <PanelBody title="Position de l'encart" initialOpen={true}>
            <PanelRow>
                <SelectControl
                    value={encartPosition}
                    onChange={(value) =>setEncartPosition(value)}
                    options={ [
                        { value: 'center', label: 'Centré' },
                        { value: 'top', label: 'Aligné vers le haut' },
                        { value: 'normal', label: 'Normal' },
                        { value: 'beside', label: 'À côté' },
                    ] }
                />
            </PanelRow>
            {encartPosition === 'beside' &&
                <PanelRow>
                    <ToggleControl
                        label={padding ? 'Avec marge' : 'Sans marge'}
                        checked={padding}
                        onChange={() =>setpadding(!padding)}
                    />
                </PanelRow>
            }
        </PanelBody>
        <PanelBody title="Arrière-plan de l'encart" initialOpen={true}>
            <PanelRow>
                <ColorPalette
                    colors={ colorsWithTransparent }
                    value={ backgroundEncart }
                    onChange={ ( value ) => setBackgroundEncart(value) }
                />
            </PanelRow>
        </PanelBody>
        <PanelBody title="Losange" initialOpen={true}>
            <PanelRow>
                <SelectControl
                    value={losangeStyle}
                    onChange={(value) =>setLosangeStyle(value)}
                    options={ [
                        { value: 'none', label: 'Aucun' },
                        { value: 'small', label: 'Petit' },
                        { value: 'large', label: 'Grand' },
                    ] }
                />
            </PanelRow>
            <PanelRow>
                <ToggleControl
                    label={losangeMiroir ? 'Droite' : 'Gauche'}
                    checked={losangeMiroir}
                    onChange={setLosangeMiroir}
                />
            </PanelRow>
        </PanelBody></>
}

function Block({fullWidth, miroir, miroirMobile, positionEncart, backgroundEncart, backgroundColor, ratio, losangeStyle, losangeMiroir, padding}){
    const {isEditing} = useEditor();
    useInspectorControl(Inspector);
    useToolbar(Toolbar);

    var blockClasses = classnames({
        [style.block]: true,
        [style.homeWidth]: fullWidth,
        [style.colWidth]: backgroundColor === style.blueBack,
    })
    
    var containerClasses = classnames({
      [style.container]: true,
      [style.flex]: positionEncart === 'beside',
      [style.reverse]: miroir,
      [style.ratio]: ratio,
      [style.reverseMobile]: miroirMobile,
      [style.admin]: isEditing
    });

    var col1Classes = classnames({
        [style.col1]: true,
        [style.encartCenter]: positionEncart === 'center',
        [style.top]: positionEncart === 'top',
        [style.beside]: positionEncart === 'beside',
        [style.dark]: backgroundEncart !== '#FFFFFF',
        [style.textPadding]: padding === true
    })

    var col2Classes = classnames({
        [style.col2]: true,
        [style.smaller]: positionEncart === 'beside',
        [style.imagePadding]: padding === true
    })

    var losangeClasses = classnames({
        [style.losange]: true,
        [style.none]: losangeStyle === 'none',
        [style.small]: losangeStyle === 'small',
        [style.large]: losangeStyle === 'large',
        [style.right]: losangeMiroir
    })

    return <div className={blockClasses} style={{backgroundColor: backgroundColor}}>
        <div className={losangeClasses}></div>
        <div className={containerClasses}>
            <div className={col1Classes} style={{backgroundColor: backgroundEncart}}>
                {isEditing ?
                <InnerBlocks allowedBlocks={[ 'core/heading', 'core/paragraph', 'core/list', 'core/separator', 'smartfire/bouton' ]} />:
                <ChildrenBlock />}
            </div>
            <div className={col2Classes}>
                <EditableImg smartProp="image" />
            </div>
        </div>
    </div>
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.any.withDefault(),
        fullWidth: smartProps.bool.withDefault(false),
        miroir: smartProps.bool.withDefault(false),
        miroirMobile: smartProps.bool.withDefault(false),
        positionEncart: smartProps.string.withDefault('normal'),
        backgroundColor: smartProps.string.withDefault(style.blueBack),
        backgroundEncart: smartProps.string.withDefault(style.blueBack),
        ratio: smartProps.string.withDefault(false),
        losangeStyle: smartProps.string.withDefault('none'),
        losangeMiroir: smartProps.bool.withDefault(false),
        padding: smartProps.bool.withDefault(false),
    }, 
    setup: {
        title: "Contenu image"
    }
});